export default __webpack_public_path__ + "static/media/Industrial Vice with Trolley.31050aff.jpg";